export const sortNewGroup = (result: any, group: Array<any>) => {
  const newGroup = group;
  const { source, destination } = result;
  const oldIndex = source.index;
  const newIndex = destination.index;
  const el = group[oldIndex];
  newGroup.splice(oldIndex, 1);
  newGroup.splice(newIndex, 0, el);
  return newGroup;
};

export const sortNewFieldGroup = (result: any, group: Array<any>) => {
  const { source, destination } = result;
  const oldIndex = source.index;
  const newIndex = destination.index;
  const oldGroupId = source.droppableId;
  const newGroupId = destination.droppableId;
  const el = group.find((g) => g.id == oldGroupId)?.fields?.[oldIndex];
  if (!el) return group;
  const newGroup = group.map((g) => {
    if (g.id === oldGroupId) {
      const newFields = g.fields;
      newFields.splice(oldIndex, 1);
      g.fields = newFields;
    }
    if (g.id == newGroupId) {
      const newFields = g.fields;
      newFields.splice(newIndex, 0, el);
      g.fields = newFields;
    }
    return g;
  });
  console.log(newGroup);
  return newGroup;
};

export const normalizeExtraData = (extraData: string) => {
  if (!extraData) return "";
  const values = extraData.split(",");
  const res: any = {};
  values.map((val, index) => {
    res[`key_${index + 1}`] = val.trim();
  });
  return JSON.stringify(res);
};
